import { prefetchModelIndex } from '@rhino-project/core/hooks';
import { createFileRoute } from '@tanstack/react-router';
import Recruiting from '../../../../components/recruiting/Recruiting';

export const Route = createFileRoute(
  '/_authenticated/$owner/active/$team_season_id/'
)({
  loader: ({ context: { rhino }, params: { team_season_id } }) => {
    return prefetchModelIndex(rhino, 'roster', {
      defaultFilter: {
        team_season_id,
        roster_status: { status_type: 'active' }
      },
      defaultLimit: 10000,
      defaultOrder: ['-quick_rating', 'player.last_name', 'player.first_name']
    });
  },
  component: RouteComponent
});

function RouteComponent() {
  return <Recruiting />;
}
